import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule, ConfigOauthService } from '@wlp/ui-bs-oauth';

const SPE_N_ACCOUNTS = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    createLiveness(callbackUri) {
        const uri = `${SPE_N_ACCOUNTS}/v1/liveness`;
        return this.api.post(uri, { callbackUri: callbackUri });
    }
    validateLiveness() {
        const uri = `${SPE_N_ACCOUNTS}/v1/liveness/validate`;
        return this.api.post(uri);
    }
    createTransactionPassword(transactionPassword) {
        const uri = `${SPE_N_ACCOUNTS}/v1/accounts/transaction`;
        return this.api.post(uri, { transaction: transactionPassword });
    }
    checkTransactionPassword(transactionPassword) {
        const uri = `${SPE_N_ACCOUNTS}/v1/accounts/transaction/check`;
        return this.api.post(uri, { token: transactionPassword });
    }
};
SpeNAccountsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountsProxy);

let UiPxUtilModule = class UiPxUtilModule {
};
UiPxUtilModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNAccountsProxy,
        ],
    })
], UiPxUtilModule);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

class CreateLivenessResponse {
}

export { ConfigService, CreateLivenessResponse, SpeNAccountsProxy, UiPxUtilModule };
//# sourceMappingURL=wlp-ui-px-util.js.map
